import React from 'react';
import { getIntl } from '../../utils/intl';
import { useOrganizationClientRecords } from '../../hooks/api/useOrganizationClientRecords';
import { APITypes, OrganizationTypes } from '../../primary-record-types';
import { AnimateLoadedContent } from '../v2BaseComponents/Loader';
import Stack from '../v2BaseComponents/Stack';
import Alert from '../v2BaseComponents/Alert';
import { clientRecordStatusTypeGuard } from '../../utils/clientRecordsUtil';

const intl = getIntl('client-invitation-id-provider', {
    inviteNotFoundTitle: 'Invitation not found',
    inviteNotFoundMessage: 'The invitation you for this client does not exist.',
});

export type ClientInvitationValue = {
    clientInvitation: APITypes.organizationService.OrganizationClientInvitationDetails;
    clientRecord: OrganizationTypes.OrganizationClientRecordForStatus<'invited'>;
};

export type ClientInvitationProviderOwnProps = {
    clientRecordId: string;
    children: (clientInvitation: ClientInvitationValue) => React.ReactNode;
};

export type ClientInvitationProviderProps = ClientInvitationProviderOwnProps;

const ClientInvitationProvider: React.FC<ClientInvitationProviderProps> = (props) => {
    const { isLoadingClientRecord, clientRecordInvitation, clientRecord, isLoadingClientRecordInvitation } =
        useOrganizationClientRecords({
            organizationClientRecordId: props.clientRecordId,
            loadClientRecordInvitation: true,
        });

    return (
        <AnimateLoadedContent isLoading={isLoadingClientRecord || isLoadingClientRecordInvitation}>
            {() =>
                clientRecordInvitation && clientRecord && clientRecordStatusTypeGuard.invited(clientRecord) ? (
                    props.children({ clientInvitation: clientRecordInvitation, clientRecord })
                ) : (
                    <Stack vertical fullHeight fullWidth align="center" justify="center">
                        <Alert
                            type="error"
                            title={intl('inviteNotFoundTitle')}
                            message={intl('inviteNotFoundMessage')}
                        />
                    </Stack>
                )
            }
        </AnimateLoadedContent>
    );
};

export default React.memo(ClientInvitationProvider);
